import React from "react";

import { Table } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { formatDate } from "../../../utils/formatDate";
import { usePermissions } from "../../../Context/permissionContext";
import * as S from "../style";

function UsersTable({ data, handleOpenModal, handleOpenInfoModal }) {
  const { permissions } = usePermissions();

  const columns = [
    {
      title: "id Portador",
      dataIndex: "idPortador",
    },

    {
      title: "Forma de Pagamento",
      dataIndex: "formaDePagamento",
    },
    {
      title: "Valor Pago",
      dataIndex: "valorPago",
      render: (valorPago) => (
        <>
          {new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(valorPago)}
        </>
      ),
    },
    {
      title: "Data Pagamento",
      dataIndex: "dataPagamento",
      render: (dataPagamento) => (
        <>{dataPagamento ? formatDate(dataPagamento) : null}</>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <>
          {status === "N" && <S.StatusActive>Normal</S.StatusActive>}
          {status === "C" && <S.StatusInactive>Cancelado</S.StatusInactive>}
          {status === "P" && <S.StatusActive>Processado</S.StatusActive>}
          {status === "D" && <S.StatusInactive>Desfeito</S.StatusInactive>}
          {status === "E" && <S.StatusInactive>Estornado</S.StatusInactive>}
          {status === "W" && <S.StatusInactive>Pendente</S.StatusInactive>}
        </>
      ),
    },
    {
      title: "Cancelar Pagamento",
      width: 170,
      dataIndex: "numeroAutorizacao",
      align: "center",
      render: (numeroAutorizacao, record) => (
        <>
          {permissions.includes("make_pay_cancel") &&
            (record.status === "N" || record.status === "P") && (
              <button
                type="button"
                className="btn-cancel"
                onClick={() => handleOpenModal(numeroAutorizacao)}
              >
                Cancelar Pagamento
              </button>
            )}
        </>
      ),
    },
    {
      title: "Loja",
      width: 80,
      align: "center",
      render: (row) => (
        <InfoCircleOutlined
          title="Ver detalhes da loja"
          data-testid="btn-info-loja"
          onClick={() => handleOpenInfoModal(row)}
          style={{ fontSize: "18px", color: "#5188F4", cursor: "pointer" }}
        />
      ),
    },
  ];

  return (
    <S.TableContainer>
      <Table
        className="tableListsadjustment not-global"
        columns={columns}
        dataSource={data?.content ? [...data.content].reverse() : []}
        pagination={{ pageSize: 5 }}
      />
    </S.TableContainer>
  );
}

export default React.memo(UsersTable);
